import { render, staticRenderFns } from "./dark.vue?vue&type=template&id=ce30cfe8&scoped=true&"
import script from "./dark.vue?vue&type=script&lang=js&"
export * from "./dark.vue?vue&type=script&lang=js&"
import style0 from "./dark.vue?vue&type=style&index=0&id=ce30cfe8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce30cfe8",
  null
  
)

export default component.exports